import React from 'react';
import { Navigate } from 'react-router-dom';
import OwningCostTab from '../components/OwningCostTab';

const OwningCostPage = ({ user }) => {
  // Only admins can access this page
  if (!user?.is_admin) {
    return <Navigate to="/maintenance/truck" replace />;
  }

  return (
    <div className="p-0">
      <OwningCostTab user={user} />
    </div>
  );
};

export default OwningCostPage;
